import React from "react";
import { Grid } from "react-bootstrap";
import { Trans } from "react-i18next";
import Card from "../../components/Card/Card.jsx";
import CustomButton from "../../components/CustomButton/CustomButton.jsx";
import EvaLogo from '../../assets/img/logo-noborder.png';
import './LoginPage.css';

const backToLogin = () => {
  window.location.href = window.location.href.split('?')[0];
};

const SsoErrorPage = () => (
  <Grid>
    <div className="center-screen">
      <Card
        hidden={false}
        textCenter
        title={
          <div>
            <img src={EvaLogo} alt={"eva-logo"} className="logo-img" />
            <br />
            Eva
            <div className="yellow-line" />
          </div>
        }
        content={
          <div className="login-form">
            <p><Trans>NO_ACCOUNT_MICROSOFT</Trans></p>
            <br />
            <div style={{ display: "flex", justifyContent: "center" }}>
              <CustomButton bsStyle="warning" fill wd onClick={backToLogin}>
                <Trans>BACK_TO_LOGIN</Trans>
              </CustomButton>
            </div>
          </div>
        }
        ftTextCenter
      />
    </div>
  </Grid>
);

export default SsoErrorPage;
